export const DECLARANT_KEY = "declarant";
export const CREATED_KEY = "created";
export const DELETED_KEY = "deleted";
export const DEPARTMENTS_DATA_KEY = "departments-data";
// export const BY_CLIENTS = "by-clients";
export const CASHBOX_KEY = "cashbox";
export const CMR_KEY = "cmr";
export const LOGISTIC_KEY = "logistic";
export const CONTRACTS_KEY = "contracts";
export const SIGMA_KEY = "sigma";
export const FLEET_EXPENSES_KEY = "fleet-expenses";
